import api from '../../../services/api';
import type { QuantityUnit } from '../../../utils/commercialQuantity';

export interface OrderProductPayload {
  id?: string;
  productVariantId?: string | null;
  name: string;
  quantity: number;
  saleUnit?: QuantityUnit;
  saleQuantity?: number;
  conversionUnit?: 'pcs' | 'm2' | 'm3' | null;
  conversionQuantity?: number;
  unitPrice?: number;
  currency?: string;
  unit: string;
  width?: number;
  height?: number;
  length?: number;
  thickness?: number;
  description?: string;
  cnCode?: string;
  netWeight?: number;
  grossWeight?: number;
  countryOfOrigin?: string;
}

export async function saveOrderProducts(
  orderId: string,
  products: OrderProductPayload[],
  currency?: string
): Promise<void> {
  await api.put(`/orders/${orderId}/products`, { products, currency });
}

export interface OrderFifoPreviewLine {
  id: string;
  purchaseUnitPrice: number | null;
  costPLN: number;
  marginPLN: number | null;
  marginPercent: number | null;
  hasShortage: boolean;
  averageCostPLN?: number | null;
}

export async function fetchOrderFifoPreview(orderId: string, products: unknown[], saved = false): Promise<OrderFifoPreviewLine[]> {
  const { data } = await api.post(`/orders/${orderId}/fifo-preview`, { products, saved });
  if (!Array.isArray(data) || data.some(line => !line || typeof line.id !== 'string'
    || !['costPLN'].every(key => typeof line[key] === 'number' && Number.isFinite(line[key]))
    || !['purchaseUnitPrice', 'marginPercent', 'marginPLN'].every(key => line[key] === null || (typeof line[key] === 'number' && Number.isFinite(line[key])))
    || (line.averageCostPLN !== undefined && line.averageCostPLN !== null && (typeof line.averageCostPLN !== 'number' || !Number.isFinite(line.averageCostPLN)))
    || typeof line.hasShortage !== 'boolean')) throw new Error('Invalid FIFO preview');
  return data;
}
